// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__Q-MU0","col":"styles_col__3n592"};